export const PERMISSION_MENU = {
  CREATE: 'MenuModule.create',
  VIEW: 'MenuModule.view',
  UPDATE: 'MenuModule.update',
  DELETE: 'MenuModule.delete',
};
